import React from 'react';
import PropTypes from 'prop-types';
import { DropzoneDialogV2 } from '../DropzoneV2';

const UploadDialogV2 = ({
  onSave,
  onClose,
  open,
  filesLimit,
  acceptedFiles,
  dialogTitle,
}) => (
  <DropzoneDialogV2
    open={open}
    onClose={onClose}
    onSave={onSave}
    acceptedFiles={acceptedFiles}
    filesLimit={filesLimit}
    maxFileSize={10000000000}
    dialogTitle={dialogTitle}
  />
);

UploadDialogV2.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  filesLimit: PropTypes.number,
  acceptedFiles: PropTypes.array,
  dialogTitle: PropTypes.string,
};

UploadDialogV2.defaultProps = {
  filesLimit: 1,
  dialogTitle: 'Importar',
};

export default UploadDialogV2;
